// extracted by mini-css-extract-plugin
export var compactFilters = "_e2-4";
export var detailImage = "_e2-1";
export var dropdownContainer = "_e2-2";
export var imageContainer = "_e2-0";
export var selectedCard = "_e2-3";